import { render, staticRenderFns } from "./SalemanLoginHistory.vue?vue&type=template&id=406909ff&scoped=true"
import script from "./SalemanLoginHistory.vue?vue&type=script&lang=js"
export * from "./SalemanLoginHistory.vue?vue&type=script&lang=js"
import style0 from "./SalemanLoginHistory.vue?vue&type=style&index=0&id=406909ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406909ff",
  null
  
)

export default component.exports